import { EpisodeCardMediumPlaceholder } from './components';

export const EpisodeCardPlaceholder = EpisodeCardMediumPlaceholder;
